export function formatWeightRange(sets = [], options = {}) {
    const { naLabel = "N/A" } = options;
    if (!Array.isArray(sets) || sets.length === 0) {
        return naLabel;
    }

    const numericWeights = sets
        .map((set) => Number(set.weight))
        .filter((value) => Number.isFinite(value) && value >= 0);

    if (numericWeights.length === 0) {
        return naLabel;
    }

    const min = Math.min(...numericWeights);
    const max = Math.max(...numericWeights);

    return min === max ? `${min}` : `${min}-${max}`;
}
